import { BaseResource } from '/@/modules/core/app/resources/BaseResource';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { Calculator } from '@/modules/tax/models/calculators/Calculator';
import CalculatorModelFactory from '@/modules/tax/factories/CalculatorModelFactory';
import { CalculatorCacheItem } from '@/modules/tax/models/calculators/CalculatorCacheItem';

export class CalculatorResource extends BaseResource {
  async calculate(params: Params = {}): Promise<Calculator> {
    const data: Record<string, unknown> = await this.postData(
      Route.TAXCALCULATION_CALCULATE,
      params
    );

    return CalculatorModelFactory.build(data);
  }

  async saveDataInCache(params: Params = {}): Promise<CalculatorCacheItem> {
    const data: Record<string, unknown> = await this.postData(
      `${Route.EXPORT_DATA}/${params.exportType}`,
      params
    );

    return CalculatorCacheItem.mapModel(data);
  }
}

export default new CalculatorResource();
